import { useRouter } from "next/navigation";
import React from "react";
import { LeftArrowIcon } from "staysure-component-library";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import { PRODUCT } from "@/constants";
import { BrandKey } from "@/types/common-types";

import Styles from "./back-to-renewal.module.css";

type BackToRenewalProps = {
  label: string;
  className?: string;
  onClick?: () => void;
};

function BackToRenewal({
  label,
  className,
  onClick,
}: Readonly<BackToRenewalProps>) {
  const router = useRouter();
  return (
    <LabelButtonWrapper
      label={label ?? "back to renewals"}
      hierarchy="tertiary"
      className={`${Styles.backToRenewalBtn} ${className} font-body-font leading-[18px] font-[600] md:text-xs text-[16px]`}
      leftIcon={<LeftArrowIcon brand={PRODUCT as Exclude<BrandKey, "expat">} />}
      isLeftIcon
      onClick={() => {
        if (onClick) onClick();
        else router.push("/");
      }}
    />
  );
}

export default BackToRenewal;
